import { PasswordInput, Space, TextInput } from "@mantine/core"
import Button from "~/components/button"
import useSignInMutation from "~/features/sign-in/hooks/useSignInMutation"
import { signInRequestSchema } from "~/features/sign-in/schema"
import showNotification from "~/shared/notification"
import { Form, Formik } from "formik"
import { useNavigate } from "react-router"
import { toFormikValidationSchema } from "zod-formik-adapter"
import type { SignInSchema as SignInFormValues } from "~/features/sign-in/schema"
import type { BaseResponse } from "~/shared/apis"
import type { AxiosError } from "axios"
import type { FormikHelpers } from "formik"

const initialValues: SignInFormValues = {
  username: "",
  password: "",
}

export default function SignInForm() {
  const navigate = useNavigate()
  const { mutateAsync: signIn } = useSignInMutation()

  const handleSubmit = async (
    values: SignInFormValues,
    { setFieldError }: FormikHelpers<SignInFormValues>
  ) => {
    const { username, password } = signInRequestSchema.parse(values)

    try {
      await signIn({ username, password })

      navigate("/project")
    } catch (error) {
      const err = error as AxiosError<BaseResponse>

      if (err.status === 401) {
        showNotification({
          title: "로그인 실패",
          message: "비밀번호가 일치하지 않습니다.",
          type: "error",
        })
        setFieldError("password", "비밀번호가 일치하지 않습니다.")
      } else {
        showNotification({
          title: "로그인 실패",
          message: "아이디 또는 비밀번호가 일치하지 않습니다.",
          type: "error",
        })
        setFieldError("username", "아이디가 일치하지 않습니다.")
        setFieldError("password", "비밀번호가 일치하지 않습니다.")
      }
    }
  }

  return (
    <Formik
      initialValues={initialValues}
      validationSchema={toFormikValidationSchema(signInRequestSchema)}
      onSubmit={handleSubmit}
    >
      {({ errors, touched, handleChange }) => (
        <Form
          style={{
            width: "250px",
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            gap: "20px",
          }}
        >
          <TextInput
            w="100%"
            radius="md"
            name="username"
            label="아이디"
            placeholder="아이디를 입력해주세요."
            onChange={handleChange}
            error={!!errors.username && !!touched.username}
          />

          <PasswordInput
            w="100%"
            radius="md"
            name="password"
            label="비밀번호"
            placeholder="비밀번호를 입력해주세요."
            onChange={handleChange}
            error={!!errors.password && !!touched.password}
          />

          <Space h="xs" />

          <Button type="submit" fullWidth>
            로그인
          </Button>
        </Form>
      )}
    </Formik>
  )
}
